import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Table, TableRow, TableRowColumn, TableBody, TableHeaderColumn, TableHeader } from 'material-ui/Table';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import IconButton from 'material-ui/IconButton';
import AutoComplete from 'material-ui/AutoComplete';
import DatePicker from 'material-ui/DatePicker';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import api from 'services';

const defaultCargo = {
    cargo: { _id: '', name: '' },
    date: null,
};

const defaultTank = {
    cargoes: [_.cloneDeep(defaultCargo), _.cloneDeep(defaultCargo), _.cloneDeep(defaultCargo)],
};

function LastCargoCell({ field, cargo, underStyle, modifiedFields, disabled, getError, changeField }) {
    const [query, setQuery] = useState(cargo.cargo.name);
    const [queryChanged, setQueryChanged] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const handleUpdateInput = (value) => {
        setQuery(value);
        if (!queryChanged) {
            setQueryChanged(true);
        }
        if (value.length < 2) return;
        api.getCargoNamesAutocomplete(value)
            .then((res) => {
                const cargoes = res.data.data.slice(0, 100).map(cargo => ({
                    _id: cargo._id,
                    name: cargo.name,
                }));
                setDataSource(cargoes);
            })
            .catch(console.error);
    };
    const handleNewRequest = (cargo) => {
        changeField({
            field: `${field}.cargo`,
            value: _.cloneDeep(cargo),
        });
    };
    const handleDateChange = (_e, date) => {
        changeField({
            field: `${field}.date`,
            value: date ? new Date(date) : null,
        });
    };
    useEffect(() => {
        if (!queryChanged && query !== cargo.cargo.name) {
            setQuery(cargo.cargo.name);
        }
    });
    return (
        <React.Fragment>
            <AutoComplete
                name={`${field}.cargo`}
                disabled={disabled}
                searchText={query}
                dataSource={dataSource}
                dataSourceConfig={{ text: 'name', value: '_id' }}
                onUpdateInput={handleUpdateInput}
                onNewRequest={handleNewRequest}
                filter={AutoComplete.noFilter}
                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                popoverProps={{ canAutoPosition: true }}
                underlineStyle={modifiedFields && modifiedFields.includes(`${field}.cargo`) ? underStyle : null}
                errorText={getError(`${field}.cargo`)}
                fullWidth
            />
            <div style={{ display: 'flex' }}>
                <DatePicker
                    autoOk
                    name={`${field}.date`}
                    maxDate={new Date()}
                    onChange={handleDateChange}
                    value={cargo.date ? new Date(cargo.date) : null}
                    formatDate={date => moment(date).format('YYYY-MM-DD')}
                    underlineStyle={modifiedFields && modifiedFields.includes(`${field}.date`) ? underStyle : null}
                    errorText={getError(`${field}.date`)}
                    fullWidth
                    style={{ flex: '1 1 auto' }}
                />
                <IconButton
                    onClick={() => handleDateChange(null, null)}
                    style={{ flex: '0 0 auto', padding: '0', width: '24px', height: '24px', marginTop: '15px' }}
                >
                    <ClearIcon color='#9e9e9e' />
                </IconButton>
            </div>
        </React.Fragment>
    );
}

/** @param {object} props */
function LastCargo({ disabled, changeField, getError, modifiedFields, underStyle, lastCargo }) {
    const handleAddTank = () => {
        changeField({
            field: 'lastCargo',
            value: [...lastCargo, _.cloneDeep(defaultTank)],
        });
    };
    const handleRemoveTank = (index) => {
        const value = lastCargo.slice();
        value.splice(index, 1);
        changeField({
            field: 'lastCargo',
            value,
        });
    };
    return (
        <Table selectable={false}>
            <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                <TableRow >
                    <TableHeaderColumn style={{ width: '80px' }}>Tank</TableHeaderColumn>
                    <TableHeaderColumn>1 Cargo</TableHeaderColumn>
                    <TableHeaderColumn>2 Cargo</TableHeaderColumn>
                    <TableHeaderColumn>3 Cargo</TableHeaderColumn>
                    <TableHeaderColumn style={{ width: '80px' }}></TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
                {(lastCargo || []).map((tank, tankIndex) => (
                    <TableRow key={`${tankIndex}`}>
                        <TableHeaderColumn style={{ width: '80px' }}>
                            {tankIndex + 1}
                        </TableHeaderColumn>
                        {tank.cargoes.map((cargo, cargoIndex) => (
                            <TableHeaderColumn key={`${cargoIndex}-${cargo._id}`}>
                                <LastCargoCell
                                    field={`lastCargo.${tankIndex}.cargoes.${cargoIndex}`}
                                    cargo={cargo}
                                    disabled={disabled}
                                    underStyle={underStyle}
                                    modifiedFields={modifiedFields}
                                    getError={getError}
                                    changeField={changeField}
                                />
                            </TableHeaderColumn>
                        ))}
                        <TableRowColumn style={{ width: '80px' }}>
                            {tankIndex === 0 && (
                                <IconButton
                                    onClick={handleAddTank}
                                    style={{ margin: '28px 0 0 8px' }}
                                >
                                    <ContentAddIcon color='green' />
                                </IconButton>
                            )}
                            {tankIndex !== 0 && (
                                <IconButton
                                    onClick={() => handleRemoveTank(tankIndex)}
                                    style={{ margin: '28px 0 0 8px' }}
                                >
                                    <ContentRemoveIcon color='red' />
                                </IconButton>
                            )}
                        </TableRowColumn>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}

export default LastCargo;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/LastCargo.jsx